import {useNavigate} from 'react-router-dom'
import {FormItemProps, Input, Checkbox} from 'antd'
import styles from './SignUpForm.module.scss'
import useStore from 'base/store'
import {Button, Form, FormItem, useForm, useWatch} from 'common/components'
import {
  FIELD_RULES,
  EMAIL_FIELD_RULES,
  PASSWORD_FIELD_RULES,
  TERMS_URL,
} from 'common/constants'
import {useSignUp} from '..'

export default function SignUpForm() {
  const navigate = useNavigate()
  const setSession = useStore((state) => state.setSession)
  const {mutate: signUp, isMutating} = useSignUp(setSession, () => {
    navigate('/login')
  })
  const [form] = useForm()
  const termsValue = useWatch('terms', form)

  const handleFinish = ({phone, terms, ...values}: any) => {
    const newValues: any = {
      ...values,
      phone: `+64${phone.trim()}`,
    }
    signUp(newValues)
  }

  return (
    <Form className={styles.root} form={form} onFinish={handleFinish}>
      <Field name="firstName" label="First name" />
      <Field name="lastName" label="Last name" />
      <Field name="email" label="Email" />
      <Field name="phone" label="Phone number" />
      <Field
        name="password"
        label="Password"
        help="Minimum 8 characters, 1 capital letter, letters and numbers"
      />
      <FormItem name="terms" valuePropName="checked" noStyle>
        <Checkbox className={styles.check}>
          I accept{' '}
          <a
            className={styles.link}
            href={TERMS_URL}
            target="_blank"
            rel="noreferrer noopener"
          >
            Terms & Conditions
          </a>
        </Checkbox>
      </FormItem>
      <div style={{height: '16px'}}></div>
      <Button
        block
        htmlType="submit"
        loading={isMutating}
        disabled={!termsValue}
      >
        Sign up
      </Button>
    </Form>
  )
}

const Field = ({name, ...props}: FormItemProps) => {
  const isEmail = name === 'email'
  const isPassword = name === 'password'

  return (
    <FormItem
      {...props}
      name={name}
      rules={
        isEmail
          ? EMAIL_FIELD_RULES
          : isPassword
          ? PASSWORD_FIELD_RULES
          : FIELD_RULES
      }
    >
      {isPassword ? (
        <Input.Password />
      ) : (
        <Input
          autoFocus={name === 'firstName'}
          addonBefore={name === 'phone' ? '+64' : undefined}
          type={isEmail ? 'email' : undefined}
        />
      )}
    </FormItem>
  )
}
